export default __webpack_public_path__ + "static/media/ceramol-iage-daytime-treatment.6ccd529c.png";